export const OWNER_CONTACT_FIELDS = [
  {
    field: "property_owner_name",
    label: "Property Owner name",
    id: "property-owner-contact-name",
    placeholder: "Jane Doe"
  },
  {
    field: "property_owner_email",
    label: "Property Owner email",
    id: "property-owner-contact-email",
    placeholder: "owner@example.com"
  },
  {
    field: "property_owner_phone",
    label: "Property Owner phone",
    id: "property-owner-contact-phone",
    placeholder: "5551234567"
  }
] as const;

export type OwnerContactField = (typeof OWNER_CONTACT_FIELDS)[number]["field"];

export type OwnerContactValues = Partial<
  Record<OwnerContactField, string | null>
>;
